import { useContext } from 'react';
import { FileUploadContext } from '../../contexts/FileUploadContext';

export const useFileUpload = () => {
  const context = useContext(FileUploadContext);
  if (context === undefined) {
    throw new Error('useFileUpload must be used within an FileUploadContext.Provider');
  }
  return context;
};
